export default "__VITE_ASSET__BKJCWBuV__"